import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(public hs: HttpService, public gs: GlobalService) { }
  async add(value: any) {
    try {
      delete value.id;
      let response = await this.hs.post('/country/add-country', {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  async delete(id: number) {
    try {
      let response = await this.hs.delete('/country/delete-country?id=' + id, {})
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  async get(id: any) {
    try {
      let response = await this.hs.get('/country/get-country?id=' + id, {})
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  async get_list(filters: any) {
    try {
      let response = await this.hs.get('/country/get-country-list', filters)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  async update(id: any, value: any) {
    try {
      let response = await this.hs.post('/country/update-country?id=' + id, {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}